export default __webpack_public_path__ + "static/media/mailIcon.9056233b.svg";